import React, { useState, useEffect, useContext } from "react";

import axios from "../../api/axios";

import { toast } from "react-toastify";
import PopUpPanel from "../../components/PopUpPanel/PopUpPanel";
import FormField from "../../components/forms/FormField/FormField";
import { CampaignContext } from "../../contexts/CampaignContext";
import HMSTimeField from "../../components/forms/HMSTimeField/HMSTimeField";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";
import RadioButtonGroup from "../../components/forms/RadioButtonGroup/RadioButtonGroup";

import { getDefaultTimeZoneListData, convertFormDateTimeTimezoneToUnixTimestamp } from "../../helpers/Dates";

import DateSelect from "../../components/forms/DateSelect/DateSelect";
import SelectUser from "../../components/SelectUser/SelectUser";
import { addStreamRoute } from "../../api/routes";
import { STREAM_STATUS_TYPES } from "../../helpers/Streams";
import { getTimezoneOptions, parseTimezone } from "../../helpers/TimeZones";
import { IconJsxer } from "../../helpers/IconHelper";

const AddStream = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [showSelectUser, setShowSelectUser] = useState(false);
    const toggleShowSelectUser = (e) => {
        if (e) {
            e.preventDefault();
        }
        setShowSelectUser(!showSelectUser);
    }
    const userSelected = (user) => {
        console.log('User selected:', user);
        // Add user to streamers list
        const channelName = user.twitchHandle || user.name;
        console.log('Channel name:', channelName);
        if (!streamers.find(s => s.twitchHandle === channelName)) {
            // Fetch profile pic
            console.log('Fetching profile pic for user:', channelName);
            props._getProfilePicFunc(channelName, (profilePic) => {
                console.log('Received profile pic:', profilePic);
                setStreamers([...streamers, { 
                    twitchHandle: channelName, 
                    discord: user.discord || '',
                    profilePic: profilePic 
                }]);
            });
        }
        setShowSelectUser(false);
    }

    const [streamName, setStreamName] = useState('');
    const [streamNameError, setStreamNameError] = useState('');
    
    const streamTypeOptions = [
        { label: 'Live stream', value: false, index: 0 },
        { label: 'Live test', value: true, index: 1 }
    ];
    const [streamType, setStreamType] = useState(streamTypeOptions[0]);
    
    const [streamers, setStreamers] = useState([]);
    const [streamersError, setStreamersError] = useState('');
    const [manualChannelName, setManualChannelName] = useState('');

    const removeStreamer = (index) => {
        setStreamers(streamers.filter((_, i) => i !== index));
    };
    
    const addManualChannel = (e) => {
        e.preventDefault();
        if (manualChannelName.trim() && !streamers.find(s => s.twitchHandle?.toLowerCase() === manualChannelName.toLowerCase())) {
            // Fetch profile pic from Twitch
            console.log('Fetching profile pic for manual channel:', manualChannelName.trim());
            props._getProfilePicFunc(manualChannelName.trim(), (profilePic) => {
                console.log('Received profile pic:', profilePic);
                setStreamers([...streamers, { 
                    twitchHandle: manualChannelName.trim(), 
                    discord: '',
                    profilePic: profilePic 
                }]);
                setManualChannelName('');
            });
        }
    };

    const [streamerHandle, setStreamerHandle] = useState('');
    const [streamerHandleError, setStreamerHandleError] = useState('');
    const [streamDiscord, setStreamDiscord] = useState('');
    const [streamDiscordError, setStreamDiscordError] = useState('');

    const [streamDate, setStreamDate] = useState(null);
    if (streamDate === null) {
        // We need to set a default date that is 00:00 our time...
        let defaultDate = new Date();
        defaultDate.setHours(0, 0, 0, 0);
        setStreamDate(defaultDate);
    }
    const dateSelected = (id, val) => {
        setStreamDate(val);
    }

    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);

    const [tzOptions, setTzOptions] = useState(getTimezoneOptions());

    const reevaluateTimezoneOptions = (selectedTimeZone = null) => {
        const utcUnix_startTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, startTime, selectedTimeZone || timezone);
        const evaluatedOptions = getTimezoneOptions(utcUnix_startTime);
        if (tzOptions !== evaluatedOptions) {
            const currentTimezone = selectedTimeZone || timezone;
            setTzOptions(evaluatedOptions);
            // Settings TzOptions can re-order the list!
            setTimezone(parseTimezone(currentTimezone.value));
        }
    }

    const [timezone, setTimezone] = useState(getDefaultTimeZoneListData(tzOptions));
    const selectTimeZone = (e, id, item) => {
        reevaluateTimezoneOptions(item);
    }

    useEffect(() => {
        reevaluateTimezoneOptions();
    }, [streamDate, startTime]);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const saveStream = (e) => {
        e.preventDefault();

        if(!isSubmitting)
        {
            let formValid = true;
            
            if (streamName === '') {
                setStreamNameError('You need to enter a stream name');
                formValid = false;
            } else {
                setStreamNameError('');
            }
            
            if (streamers.length === 0) {
                setStreamersError('You need to add at least one streamer');
                formValid = false;
            } else {
                setStreamersError('');
            }

            if (formValid) {
                let utcUnix_startTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, startTime, timezone);
                let utcUnix_endTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, endTime, timezone);

                if(!isSubmitting)
                {
                    // do axios post here
                    setIsSubmitting(true);
                    axios
                    .post(addStreamRoute, { 
                        campaignID:props.campaignId,
                        status:STREAM_STATUS_TYPES.scheduled.dbString,
                        name: streamName,
                        demoMode: streamType.value,
                        channels: streamers,
                        discord:streamDiscord,
                        startTime:utcUnix_startTime,
                        endTime:utcUnix_endTime,
                        timeZone:timezone.value, 
                        withCredentials:true
                    })
                    .then((response) =>{
                        console.log(response)

                        let oldCampaignData = campaignContext.campaignData
                        oldCampaignData.streams = response.data.campaignData.streams;
                        setIsSubmitting(false);
                        setCampaignContext((oldValues) => {
                            return { ...oldValues, initialising: false, campaignData: oldCampaignData }
                        })

                        toast.success("Stream ("+streamName+") successfully added to campaign");
                        props.closePanelFunc();
                    })
                }
                
            }
        }
    }

    return (
        <>
        {!showSelectUser &&
        <PopUpPanel closePanelFunc={props.closePanelFunc}>
            <div className="form-holder co-popup-content">
                <form id="addstream" className="form">
                    <h2>Create new stream</h2>
                    
                    <FormField
                        type="text"
                        id="stream_name"
                        placeholder="Enter Stream Name"
                        setFunc={setStreamName}
                        label="Stream name*"
                        error={streamNameError}
                        value={streamName}
                    />
                    
                    <FormDropDown
                        id="stream_type"
                        label="Stream type"
                        showLabel={true}
                        items={streamTypeOptions}
                        currentIndex={streamType.index}
                        selectFunc={(e, id, item) => setStreamType(item)}
                    />
                    
                    <div className="label">Day</div>
                    <div className="fl-row drop-gap grow">
                        <DateSelect 
                            id="stream_date" 
                            allowPast={false}
                            initialDate={streamDate}
                            selectFunc={dateSelected}
                        />
                    </div>  
                    
                    <div className="label">Time</div>
                    <div className="fl-row time-row-inline">
                        <HMSTimeField
                            label="Start"
                            inlineLabel={true}
                            showLabel={false}
                            id="stream_start"
                            value={startTime}
                            setFunc={setStartTime}
                            maxHours={23}
                            showSeconds={false}
                            relativeTime={false}
                            narrow={true}
                            centered={false}
                            showError={false}
                        />
                        <div className="time-separator">to</div>
                        <HMSTimeField
                            label="Until"
                            inlineLabel={true}
                            showLabel={false}
                            id="stream_end"
                            value={endTime}
                            setFunc={setEndTime}
                            maxHours={23}
                            showSeconds={false}
                            relativeTime={false}
                            narrow={true}
                            centered={false}
                            showError={false}
                        />
                    </div>
                    <div className="row timezone-row">
                         <div className="timezone-inline">
                            <FormDropDown
                                id="timezone"
                                label="Timezone"
                                showLabel={false}
                                items={tzOptions}
                                currentIndex={timezone.index}
                                selectFunc={selectTimeZone}
                            />
                        </div>
                    </div>
                    
                    <div className="label">Streamers</div>
                    {streamersError && <div className="error-text">{streamersError}</div>}
                    <div className="streamers-list">
                        {streamers.map((streamer, index) => (
                            <div key={index} className="streamer-item">
                                <div className="streamer-info">
                                    {streamer.profilePic ? (
                                        <img src={streamer.profilePic} alt={streamer.twitchHandle} className="streamer-avatar" />
                                    ) : (
                                        <div className="streamer-avatar-placeholder"></div>
                                    )}
                                    <span>{streamer.twitchHandle}</span>
                                </div>
                                <button 
                                    type="button"
                                    className="remove-streamer-btn"
                                    onClick={() => removeStreamer(index)}
                                >
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.trash)}
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="add-streamer-section">
                        <div className="manual-channel-input">
                            <input
                                type="text"
                                placeholder="Enter channel name"
                                value={manualChannelName}
                                onChange={(e) => setManualChannelName(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        addManualChannel(e);
                                    }
                                }}
                            />
                            <button 
                                type="button"
                                className="add-manual-btn"
                                onClick={addManualChannel}
                                disabled={!manualChannelName.trim()}
                            >
                                Add
                            </button>
                        </div>
                        <button 
                            type="button"
                            className="add-streamer-btn" 
                            onClick={toggleShowSelectUser}
                        >
                            {IconJsxer.GetIcon(IconJsxer.ICONS.plus)}
                            Add from user list
                        </button>
                    </div>
                    
                    <button className={'submit-btn' + (isSubmitting ? ' button-inactive' : ' button-active')} onClick={isSubmitting ? null : saveStream}>
                        {isSubmitting ? "Creating stream" : "Create stream"}
                    </button>
                </form>
            </div>
        </PopUpPanel>
        }
        {showSelectUser &&
            <SelectUser closePanelFunc={toggleShowSelectUser} selectUserFunc={userSelected} twitchOnly={true} />
        }
        </>
    )
}

export default AddStream;
